import React, { createRef } from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../../Shared/Icon/Icon'

const PriceOfferNegotiateSection = ({ offerId, onPriceOfferSubmitSuccess, conversationId }) => {
  const onSubmit = e => {
    e.preventDefault()

    return onPriceOfferSubmit(priceField.current.value)
  }

  const onPriceOfferSubmit = (value) => {
    const payload = { status: 'in_progress', conversation_id: conversationId, offer_price: value }

    axios.post(`/api/internal/price_offers/${offerId}`, payload)
      .then(onPriceOfferSubmitSuccess)
      .catch(onPriceOfferSubmitFailure)
  }

  const onPriceOfferSubmitFailure = (error) => {
    return App.events.publish('app:notification:flash:error', error.response.data.error)
  }

  const priceField = createRef()

  return (
    <span>
      <div className="conversation__offer-value">
        <div className="input-container">
          <div className="field-wrapper">
            <div className="field-suffix">$</div>
            <input type="text" name="price_offer_price" className="field" ref={priceField} />
          </div>
        </div>
      </div>
      <button className="button button--dark" onClick={onSubmit}>
        <Icon type={['far', 'handshake']} />
        Negotiate
      </button>
    </span>
  )
}

PriceOfferNegotiateSection.propTypes = {
  onPriceOfferSubmitSuccess: PropTypes.func.isRequired,
  offerId: PropTypes.number.isRequired,
  conversationId: PropTypes.number.isRequired,
}

export default PriceOfferNegotiateSection
